import { ERequestDemandField } from '../../../constants/requestDemand';

const masks = {
  [ERequestDemandField.EMAIL]: /^.+@.+\..+$/,
  [ERequestDemandField.PHONE]: /^\+\d\s\d{3}\s\d{3}-\d{2}-\d{2}$/,
};

export const didMatchWithMask = (name: keyof typeof masks, value: string): boolean =>
  masks[name] ? masks[name].test(value) : true;
